var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shouldShow
    ? _c("div", [
        _vm.regionContentRating
          ? _c("small", { class: _vm.$style.textBlock }, [
              _vm._v(_vm._s(_vm.regionContentRating))
            ])
          : _vm.contentRatingMessage
          ? _c("small", { class: _vm.$style.textBlock }, [
              _vm._v(
                _vm._s(
                  _vm.$t("video.info.content_rating", {
                    content_rating: _vm.contentRatingMessage
                  })
                )
              )
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }